module.exports = __webpack_public_path__ + "public/images/todayshow@2x.3a20c25d8617fb9835d8356c4bfde3ca.png";